import {
  GET_CLOCK_IN_OUT_LIST,
  GET_CLOCK_IN_OUT_LIST_FAILURE,
  GET_CLOCK_IN_OUT_LIST_SUCCESS,
  LOGIN_PROFILE_CREATED_RESET,
  FETCH_ATTENDANCE_TIMELINE,
  FETCH_ATTENDANCE_TIMELINE_SUCCESS,
  FETCH_ATTENDANCE_TIMELINE_FAILURE,
} from '../../modules/constants';

export const clockInOutListRequestHandler = (state, action) => {
  return {
    ...state,
    isLoading: true,
  };
};
export const clockInOutListRequestSuccessHandler = (state, action) => {
  const {
    payload: { data },
  } = action;
  return {
    ...state,
    isLoading: false,
    // clockInOutListCount: data.data.count,
    // clockInOutPageSize: data.data.page_size,
    clockInOutList: data.data,
  };
};
export const clockInOutListRequestFailureHandler = (state, action) => {
  return {
    ...state,
    isLoading: false,
    clockInOutListCount: null,
    clockInOutPageSize: null,
    clockInOutList: [],
  };
};

export const handleLogoutRequest = (state, action) => {
  return {
    ...initialState,
  };
};

export const fetchAttendanceTimelineRequestHandler = (state, action) => {
  return {
    ...state,
    attendanceTimelineLoading: true,
  };
};

export const fetchAttendanceTimelineRequestSuccessHandler = (state, action) => {
  const {
    payload: { data },
  } = action;
  return {
    ...state,
    attendanceTimelineLoading: false,
    attendanceTimeline: data.data,
  };
};

export const fetchAttendanceTimelineRequestFailureHandler = (state, action) => {
  return {
    ...state,
    attendanceTimelineLoading: false,
    attendanceTimeline: [],
  };
};

const ACTION_HANDLERS = {
  [GET_CLOCK_IN_OUT_LIST]: clockInOutListRequestHandler,
  [GET_CLOCK_IN_OUT_LIST_SUCCESS]: clockInOutListRequestSuccessHandler,
  [GET_CLOCK_IN_OUT_LIST_FAILURE]: clockInOutListRequestFailureHandler,

  [LOGIN_PROFILE_CREATED_RESET]: handleLogoutRequest,

  [FETCH_ATTENDANCE_TIMELINE]: fetchAttendanceTimelineRequestHandler,
  [FETCH_ATTENDANCE_TIMELINE_SUCCESS]: fetchAttendanceTimelineRequestSuccessHandler,
  [FETCH_ATTENDANCE_TIMELINE_FAILURE]: fetchAttendanceTimelineRequestFailureHandler,
};

const initialState = {
  isLoading: false,
  clockInOutList: [],

  // pagination
  clockInOutListCount: null,
  clockInOutPageSize: null,

  attendanceTimelineLoading: false,
  attendanceTimeline: [],
};

export default function clockInOutReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}
